var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icons-in",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f93",
    d: "M0 0h512v170.7H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 170.7h512v170.6H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#128807",
    d: "M0 341.3h512V512H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(256 256) scale(3.41333)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 20,
    fill: "#008"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 17.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.5,
    fill: "#008"
  }), /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    fill: "#008"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 0.9,
    transform: "rotate(7.5 -8.8 133.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 17.5.6 7 0 2l-.6 5L0 17.5z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    transform: "rotate(15)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    transform: "rotate(30)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: "100%",
    height: "100%",
    transform: "rotate(60)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    width: "100%",
    height: "100%",
    transform: "rotate(120)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    width: "100%",
    height: "100%",
    transform: "rotate(-120)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.a8b035d61b54fec572a00298f9a05aaa.svg";
export { ForwardRef as ReactComponent };